<template>
  <div class="content">
    <div class="md-layout">
      <!--  Loading: Clients -->
      <div
        v-if="isClientsLoading || isEventsLoading || isSubscriptionsLoading"
        class="md-layout-item"
      >
        <LoadingData />
      </div>

      <div v-else class="md-layout-item">
        <!--  Empty Data Handler -->
        <div v-if="isClientsEmpty">
          <EmptyData emptyText="You have not created any API credential" />
          <md-button class="md-primary" @click="createClient()"
            >Create API Credentials</md-button
          >
        </div>
        <!-- Data Exist Handler -->
        <div v-else>
          <div>
            <div
              class="md-layout-item md-small-size-100 md-size-75 justify-end"
            >
              <md-table>
                <md-table-row>
                  <md-table-head>Events</md-table-head>
                </md-table-row>
                <md-table-row v-for="(event, index) in events" :key="index">
                  <md-table-cell md-label="Service" style="width: 90%">
                    <md-field>
                      <label>{{ event.name }}</label>
                      <md-input
                        type="text"
                        v-model="event.notification_url"
                        @input="validateSingleUrl(event, index)"
                      ></md-input>
                      <span class="md-helper-text">{{
                        event.description || "No Description"
                      }} {{errorBag[event.code]}}</span>
                      <span class="text-danger" v-if="errorBag[event.code]">Invalid URL</span>
                    </md-field>
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </div>

            <md-button
              class="md-primary"
              @click="subscribeToEvent"
              v-if="this.events.length > 0"
              >Save Change</md-button
            >
          </div>
        </div>
      </div>
    </div>

    <md-snackbar
      md-position="center"
      :md-duration="6000"
      :md-active.sync="snackBar.show"
      md-persistent
    >
      <span>{{ snackBar.message }}</span>
    </md-snackbar>
  </div>
</template>

<script>
import Validator from '@/utils/Validator';
import http from '../../../utils/Http.util';
import EmptyData from '../../../components/EmptyData.vue';
import LoadingData from '../../../components/LoadingData.vue';

export default {
  components: {
    EmptyData,
    LoadingData,
  },
  created() {
    this.getData();
  },
  watch: {
    activeClient() {
      this.getSubscriptions();
    },
  },

  computed: {
    activeBusiness() {
      return this.$store.state.activeBusiness;
    },
    isEventsEmpty() {
      return !this.events.length;
    },
    isClientsEmpty() {
      return !this.clients.length;
    },
    isLive() {
      return this.$store.state.isLive;
    },
  },

  data() {
    return {
      clients: [],
      environment: { test: {}, production: {} },
      isEventsLoading: false,
      isClientsLoading: false,
      isSubscriptionsLoading: false,
      isSubscribeLoading: false,
      isCreateLoading: false,
      activeClient: 'test',
      events: [],
      subscriptions: [],
      snackBar: {
        show: false,
        message: null,
      },
      errorBag: {},
    };
  },
  methods: {
    async getData() {
      await this.loadClients();
      await this.getEvents();
      await this.getSubscriptions();
    },
    getEnvironments() {
      if (this.clients.length) {
        this.clients.forEach((client) => {
          if (client.type === 'test') {
            this.environment.test = client;
          } else if (client.type === 'production') {
            this.environment.production = client;
          }
        });
      }
    },
    async createClient() {
      this.$store.commit('busyStatus', true);
      try {
        this.isCreateLoading = true;
        const { message } = await http.authReq(
          '/dashboard/clients',
          {},
          'post',
        );
        this.loadClients();
        this.snackBar = {
          show: true,
          message,
        };
        this.isCreateLoading = false;
        this.$store.commit('busyStatus', false);
      } catch (error) {
        this.snackBar = {
          show: true,
          message: error.response ? error.response.data.message : error.message,
        };
        this.isCreateLoading = false;
        this.$store.commit('busyStatus', false);
      }
    },
    toggleSwitch(selectedEvent) {
      this.events.forEach((event, index) => {
        if (event.code === selectedEvent.code) {
          this.events[index].active = !selectedEvent.active;
        }
      });
      this.$forceUpdate();
    },
    async loadClients() {
      try {
        this.isClientsLoading = true;
        const { data } = await http.authReq('/dashboard/clients');
        this.clients = data;
        await this.getEnvironments();
        this.isClientsLoading = false;
      } catch (error) {
        this.snackBar = {
          show: true,
          message: error.response ? error.response.data.message : error.message,
        };
        this.isClientsLoading = false;
      }
    },
    async getEvents() {
      try {
        this.isEventsLoading = true;

        const { data } = await http.authReq('/dashboard/events');

        this.events = data;

        this.isEventsLoading = false;
      } catch (error) {
        this.snackBar = {
          show: true,
          message: error.response ? error.response.data.message : error.message,
        };

        this.isEventsLoading = false;
      }
    },
    async getSubscriptions() {
      this.isSubscriptionsLoading = true;
      try {
        const { data, message } = await http.authReq(
          '/dashboard/clients/event-subscriptions',
        );

        this.subscriptions = data;

        this.setActiveSubscriptions();

        this.isSubscriptionsLoading = false;

        this.snackBar = {
          show: true,
          message,
        };
      } catch (error) {
        this.snackBar = {
          show: true,
          message: error.response ? error.response.data.message : error.message,
        };

        this.isSubscriptionsLoading = false;
      }
    },

    setActiveSubscriptions() {
      const { events } = this;

      events.forEach((event) => {
        const webhookEvent = event;
        webhookEvent.notification_url = '';
        webhookEvent.active = false;

        const subscription = this.subscriptions.find((item) => item.event_code === event.code);
        if (subscription) {
          event.notification_url = subscription.notification_url;
          event.active = true;
        }
      });

      this.events = events;
    },
    async subscribeToEvent() {
      this.$store.commit('busyStatus', true);
      this.isSubscribeLoading = true;

      this.errorBag = {};
      this.events.some((event, index) => event.notification_url !== '' && this.isValidNotificationUrl(event, index));
      if (Object.keys(this.errorBag).length > 0) {
        this.isSubscribeLoading = false;
        this.$store.commit('busyStatus', false);
        return;
      }

      try {
        const eventSubscriptions = await this.formatSubmittedFields(this.events);

        const { message } = await http.authReq(
          '/dashboard/clients/event-subscriptions/',
          { data: eventSubscriptions },
          'patch',
        );

        this.isSubscribeLoading = false;
        this.$store.commit('busyStatus', false);

        this.snackBar = {
          show: true,
          message,
        };
      } catch (error) {
        this.snackBar = {
          show: true,
          message: error.response ? error.response.data.message : error.message,
        };

        this.isSubscribeLoading = false;
        this.$store.commit('busyStatus', false);
      }
    },
    formatSubmittedFields(events) {
      const newEvents = [];
      events.forEach((event) => {
        const tempEvent = {
          event_code: event.code,
          notification_url: event.notification_url,
          active: event.active,
        };
        newEvents.push(tempEvent);
      });
      return newEvents;
    },

    isValidNotificationUrl(event, index) {
      const url = event.notification_url;
      this.events[index].isValueUrl = Validator.url(url);
      if (this.events[index].isValueUrl) {
        this.errorBag[event.code] = true;
        return false;
      }
      return true;
    },
  },
};
</script>

<style scoped>
.md-table-row {
  border-bottom: 2px solid white !important;
}
</style>
